<div class="min-h-screen flex items-center justify-center p-4">
    <div class="max-w-md w-full bg-white rounded-[2.5rem] shadow-2xl overflow-hidden transition-all duration-500 hover:shadow-3xl relative">
      <!-- Decorative Elements -->
      <div class="absolute -top-20 -right-20 w-40 h-40 bg-purple-200/30 rounded-full blur-xl"></div>
      <div class="absolute -bottom-20 -left-20 w-40 h-40 bg-purple-200/30 rounded-full blur-xl"></div>
      
      <!-- Header Section -->
      <div class="bg-gradient-to-br from-purple-600 to-purple-800 text-white pt-12 pb-16 px-10 relative overflow-hidden">
        <div class="absolute -right-10 -top-10 w-32 h-32 bg-white/10 rounded-full"></div>
        <div class="absolute -left-10 -bottom-10 w-32 h-32 bg-white/10 rounded-full"></div>
        
        <div class="relative z-10 flex items-center justify-between">
          <div class="space-y-2">
            <h2 class="text-4xl font-bold tracking-tight">Welcome Back</h2>
            <p class="text-purple-100/90">Secure Admin Dashboard Access</p>
          </div>
          <div class="float-icon bg-white/20 p-4 rounded-2xl">
            <svg class="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"></path>
            </svg>
          </div>
        </div>
      </div>
  
      <!-- Form Section -->
      <div class="px-10 py-12 relative">
        <form #loginForm="ngForm" (ngSubmit)="onSigninClick()" class="space-y-8">
          <div class="space-y-6">
            <div class="group">
              <label class="block text-sm font-medium text-purple-900/80 mb-2 ml-1">Email Address</label>
              <input 
                type="email" 
                required
                [(ngModel)]="email"
                name="email"
                #emailInput="ngModel"
                [ngClass]="{'border-red-500': isError, 'border-purple-200': !isError}"
                class="w-full px-5 py-3 rounded-xl border bg-white transition-all duration-300 input-glow focus:ring-0 placeholder-purple-400/60 hover:border-purple-400"
                placeholder="Enter your email"
              >
            </div>
            
            <div class="group">
              <label class="block text-sm font-medium text-purple-900/80 mb-2 ml-1">Password</label>
              <input 
                type="password" 
                required
                [(ngModel)]="password"
                name="password"
                #passwordInput="ngModel"
                [ngClass]="{'border-red-500': isError, 'border-purple-200': !isError}"
                class="w-full px-5 py-3 rounded-xl border bg-white transition-all duration-300 input-glow focus:ring-0 placeholder-purple-400/60 hover:border-purple-400"
                placeholder="Enter your password"
              >
            </div>
            
            <!-- Error Message -->
            <div *ngIf="isError" class="text-red-500 text-sm mt-2">
              Invalid email or password
            </div>
          </div>
  
          <div class="flex items-center justify-between">
            <label class="flex items-center space-x-3 cursor-pointer">
              <input type="checkbox" class="h-5 w-5 accent-purple-600 rounded-lg border-purple-300">
              <span class="text-sm text-purple-800/80">Remember me</span>
            </label>
            <a href="#" class="text-sm font-medium text-purple-600 hover:text-purple-800 transition-colors">
              Forgot Password?
            </a>
          </div>
  
          <button type="submit" 
            class="w-full py-3 px-6 bg-gradient-to-r from-purple-600 to-purple-700 
                   text-white rounded-xl font-semibold 
                   transition-all duration-300 hover:scale-[1.02] 
                   hover:shadow-lg hover:from-purple-700 hover:to-purple-800
                   active:scale-95 flex items-center justify-center space-x-2">
            <span>Sign In</span>
            <svg class="w-5 h-5 -mr-2 transition-all duration-300 group-hover:translate-x-1" 
                 fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 8l4 4m0 0l-4 4m4-4H3"></path>
            </svg>
          </button>
        </form>
  
        <div class="mt-8 text-center">
          <p class="text-sm text-purple-600/80">
            Need assistance? 
            <a href="#" class="font-semibold text-purple-800 hover:text-purple-900 underline">
              Contact Support
            </a>
          </p>
        </div>
      </div>
    </div>
  </div>